import { useState } from 'react'
import { ATTRIBUTE_TYPES } from 'Constants/attributes.constants'
import { TextAreaAttributeProps } from 'Types/Attribute.types'
import AIConversationIcon from 'Assets/icons/ai-conversation-icon.svg'
import {
    AIAssistanceBodyType,
    ConversationSenderType,
    ConversationMessageType,
} from 'Types/AIAssistance.types'
import HtmlRenderer from 'Utils/htmlRenederer.utils'
import TextAreaAttribute from 'Components/attributes/TextAreaAttribute/TextArea'
import styles from './AIAssistance.module.less'
import CopyButton from '../../../components/common/CopyButton/CopyButton'
import { sendAnalyticsTrack } from 'Utils/analytics.utils.ts'
import Divider from 'antd/lib/divider'
import Button from 'antd/lib/button'

export const AIAssistanceBody = (props: AIAssistanceBodyType) => {
    const [loading, setLoading] = useState(false)
    const attributes: TextAreaAttributeProps = {
        id: 'ai-assistance',
        type: ATTRIBUTE_TYPES.TEXTAREA,
        label: '',
        placeholder: 'Start typing your query here...',
        value: props.input,
        onChange: (value: string | undefined) => {
            props.updateInput(value || '')
        },
        showCount: true,
        allowClear: true,
        rows: 6,
        width: 'calc(100% - 15px)',
        className: styles['ai-assistance-textarea'],
    }

    return (
        <div className={styles['ai-assistance-body']} data-testid="ai-assistance-body">
            <div className={styles['conversations']}>
                {loading && (
                    <div className={styles[`ai-loader`]}>
                        <span className={styles['ai-loader-icon']}>
                            <img src={AIConversationIcon} alt="AI Conversation Icon" />
                        </span>
                        <span className={styles['ai-loader-text']}>...</span>
                    </div>
                )}
                {[...props.conversations]
                    .reverse()
                    .map((conversation: ConversationMessageType, index: number) => {
                        if (conversation.sender !== ConversationSenderType.DIVIDER) {
                            return (
                                <div
                                    className={
                                        styles['conversation'] + ' ' + styles[conversation.sender]
                                    }
                                    key={conversation.sender + '-' + index}
                                >
                                    <HtmlRenderer htmlContent={conversation.message} />

                                    {conversation.sender === ConversationSenderType.BOT && (
                                        <>
                                            <span className={styles['ai-icon']}>
                                                <img
                                                    src={AIConversationIcon}
                                                    alt="AI Conversation Icon"
                                                />
                                            </span>

                                            <div className={styles['copy-icon']}>
                                                <CopyButton
                                                    contentToCopy={
                                                        props.conversations[
                                                            props.conversations.length - index - 1
                                                        ].message
                                                    }
                                                    onClick={() =>
                                                        sendAnalyticsTrack(
                                                            'AiAssistance_Response_Copied',
                                                            {
                                                                project_id:
                                                                    props.taskConfig.assignment
                                                                        .project_id,
                                                                task_id:
                                                                    props.taskConfig.assignment.task
                                                                        .id,
                                                                user_id:
                                                                    props.taskConfig.assignment
                                                                        .user_id,
                                                                step_id:
                                                                    props.taskConfig.assignment.step
                                                                        ?.id,
                                                                count_of_messages:
                                                                    props.conversations.length,
                                                                conversation_id: props.contextId,
                                                            }
                                                        )
                                                    }
                                                />
                                            </div>
                                        </>
                                    )}
                                </div>
                            )
                        } else {
                            return (
                                <Divider
                                    plain
                                    key={index + '-' + conversation.sender}
                                    className={styles['divider']}
                                >
                                    {conversation.message}
                                </Divider>
                            )
                        }
                    })}
            </div>
            <div className={styles['input-container']}>
                <TextAreaAttribute {...attributes} />
                <div className={styles['button-container']}>
                    <Button
                        disabled={props.input.length === 0}
                        className={styles['input-button']}
                        onClick={async () => {
                            setLoading(true)
                            await props.onSubmitButton()
                            setLoading(false)
                        }}
                    >
                        Ask AI
                    </Button>
                </div>
            </div>
        </div>
    )
}
